export const APPLY_TO_DW_STEPS = [
  { id: 0, label: "Select Objects" },
  { id: 1, label: "Selected Objects" },
  { id: 2, label: "Confirm" },
];
